import React from 'react';

export interface Toast {
  id: number;
  title?: string;
  message?: React.ReactNode;
  type?: 'info' | 'success' | 'warning' | 'error';
}

type Listener = () => void;

let toasts: Toast[] = [];
let nextId = 0;
const listeners = new Set<Listener>();

const emit = () => listeners.forEach((listener) => listener());

export const addToast = (toast: Omit<Toast, 'id'>) => {
  nextId += 1;
  toasts = [{ ...toast, id: nextId }, ...toasts];
  emit();
};

export const removeToast = (id: number) => {
  toasts = toasts.filter((t) => t.id !== id);
  emit();
};

export const subscribe = (listener: Listener) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);

    // No ToastProvider is mounted any more (e.g. test cleanup between cases) — drop
    // any toasts left over so a freshly mounted provider doesn't inherit stale state.
    if (listeners.size === 0) {
      toasts = [];
    }
  };
};

export const getToasts = () => toasts;
